import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, message } from 'antd'
import dayjs from 'dayjs'
import { modalError } from '@/utils/modalUtils'
import { listAsnLine, getExportAsnLine } from '@/services/returnReport/receiptData'
import { getConfigQuery } from '@/services/orderQuery/byBatch'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import {
  // paginationInit,
  formatMessage,
  formatStartTime,
  formatEndTime,
  dateFormatYearMonthDay,
  dateFormatYearMonthDay2,
  uniqueFun,
  initValueAndLabel
} from '@/utils/common'
import { QUALITY_INSPECTION_RESULTS } from '@/utils/types'
const ReceiptData = props => {
  const mounting = useRef(false)
  let formRef = useRef(null)
  const [tableList, setTableList] = useState([])
  let searchListInit = [
    {
      type: 'timeRange',
      label: 'languageObj.receiptData.rwCollectionDate',
      key: 'rwCollectionDate',
      showRangePresets: true,
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: []
    },
    {
      type: 'textArea',
      label: 'languageObj.receiptData.omsReturnCode',
      key: 'omsReturnCode',
      autoSize: { minRows: 3, maxRows: 3 },
      initialValues: '',
      placeholder: formatMessage('languageObj.commonLocale.placeholderFormat')
    },
    {
      type: 'select',
      label: 'languageObj.receiptData.defectReason',
      key: 'defectReason',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: QUALITY_INSPECTION_RESULTS
    }
  ]

  const [searchList, setSearchList] = useState(searchListInit)
  // 查询标志
  const [queryFlag, setQueryFlag] = useState(false)
  // const [pagination, setPagination] = useState(paginationInit)
  const tableColumns = [
    {
      title: formatMessage('languageObj.receiptData.warehouseReceiptLineNumber'),
      dataIndex: 'id',
      width: 90,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.receiptNumber'),
      dataIndex: 'asn_id',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.receiptCreationTime'),
      dataIndex: 'asn_create_time',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.receiptStatus'),
      dataIndex: 'asn_status',
      width: 80,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.omsReturnRxchangeCode'),
      dataIndex: 'asn_ext_code',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.returnTrackingNumber'),
      dataIndex: 'atm_tracking_number',
      width: 80,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.packageStatus'),
      dataIndex: 'rrp_package_status',
      width: 80,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.rwCollectionTime'),
      dataIndex: 'rrp_register_time',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.abnormalPackageNumber'),
      dataIndex: 'tsp_code',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.processingStatus'),
      dataIndex: 'tsp_oms_status',
      width: 70,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.receiptData.qualityInspectionResult'),
      dataIndex: 'arl_defect_reasons',
      width: 70,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  useEffect(() => {
    if (mounting.current) {
      searchDataFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getConfigQueryFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // 获取下拉框数据
  const getConfigQueryFun = () => {
    Promise.all([getConfigQuery({ configType: 'arl_defect_reasons' })]).then(res => {
      try {
        searchListInit.forEach(itemFirst => {
          if (itemFirst.key === 'defectReason') {
            let uniqueRes = []
            switch (itemFirst.key) {
              case 'defectReason':
                let data0 = res[0].resultData || []
                uniqueRes = initValueAndLabel(data0, {
                  value: 'configKey',
                  label: 'configValue'
                })
                break
              default:
                uniqueRes = []
                break
            }
            let unique = uniqueFun(uniqueRes)
            itemFirst.selectList = unique
          }
        })
        setSearchList([...searchListInit])
      } catch (error) {
        console.log(error)
      }
    })
  }
  const searchDataBtn = () => {
    // const pg = {
    //   ...pagination,
    //   currentPage: 1
    // }
    // setPagination(pg)
    mounting.current = true
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    // const pg = {
    //   ...pagination,
    //   currentPage: 1
    // }
    // setPagination(pg)
    // setQueryFlag(!queryFlag)
  }
  const getSearchInfo = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}

    let omsReturnCode = info.omsReturnCode ? info.omsReturnCode.split('\n').filter(Boolean) : []
    let { rwCollectionDate } = info
    let registerDateStart = formatStartTime(rwCollectionDate, 2, dateFormatYearMonthDay2)
    let registerDateEnd = formatEndTime(rwCollectionDate, 2, dateFormatYearMonthDay2)
    let defectReason = info.defectReason.join(',')
    const params = {
      ...info,
      registerDateStart,
      registerDateEnd,
      defectReason,
      omsReturnCode: omsReturnCode.join(',')
    }
    delete params.rwCollectionDate
    return params
  }
  const searchDataFun = () => {
    let info = getSearchInfo()
    let { omsReturnCode } = info
    let codeLs = omsReturnCode.split(',')
    if (codeLs && codeLs.length > 200) {
      modalError({
        content: formatMessage('languageObj.receiptData.maxErrorTitle')
      })
      return
    }
    const params = {
      ...info
      // size: pagination.pageSize,
      // pageNo: pagination.currentPage
    }
    listAsnLine(params).then(res => {
      const dt = res.resultData
      const records = dt.records
      setTableList(records)
      // const pg = {
      //   ...pagination,
      //   total: dt.total
      // }
      // setPagination(pg)
    })
  }
  // 分页查询
  // const handleTableChange = pagina => {
  //   const params = {
  //     ...pagination,
  //     currentPage: pagina.current,
  //     pageSize: pagina.pageSize
  //   }
  //   setPagination({ ...params })
  //   setQueryFlag(!queryFlag)
  // }
  // 导出结果
  const downLoadFun = () => {
    let info = getSearchInfo()
    const params = {
      ...info
    }
    getExportAsnLine(params).then(res => {
      message.success(formatMessage('languageObj.byBatchLocale.downloadTip'))
    })
  }
  return (
    <div>
      <Card>
        <div className="search-bar">
          <SearchBar ref={formRef} searchList={searchList}></SearchBar>
          <div className="mt10">
            <div className="right_search">
              <Button type="primary" onClick={searchDataBtn}>
                {formatMessage('languageObj.commonLocale.search')}
              </Button>
              <Button onClick={searchClearDataBtn}>{formatMessage('languageObj.commonLocale.clear')}</Button>
              <Button type="primary" onClick={downLoadFun}>
                {formatMessage('languageObj.byBatchLocale.exportResults')}
              </Button>
            </div>
          </div>
        </div>
      </Card>

      <Card className="mt15">
        <div className="content-container">
          <div>
            <AntdTable
              title={() => (
                <div>
                  <div className="defaultColor">{formatMessage('languageObj.byBatchLocale.tableTitle')}</div>
                </div>
              )}
              dataSource={tableList}
              columns={tableColumns}
              // pagination={pagination}
              pagination={false}
              // onChange={handleTableChange}
            />
          </div>
        </div>
      </Card>
    </div>
  )
}
export default ReceiptData
